// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"4f0f732f","613":"3022240e"}[chunkId] + ".chunk.js";
};